import { CurrencyCode } from "../currencies"
import { CardType, CatalogItem } from "./catalog-table/types"

export const CATALOG_CATEGORIES = [
  "All categories",
  "Prepaid cards",
  "Gift cards",
  "Monetary options",
  "Charities",
] as const

export const ALL_CATEGORIES = CATALOG_CATEGORIES[0]

export type CategoryKey = (typeof CATALOG_CATEGORIES)[number]

export interface CategoryProps {
  downloadable: boolean
  category?: CategoryKey
}

export const CATEGORY_CARD_TYPE_MAP: Record<
  CategoryKey,
  Nullable<CardType[]>
> = {
  "All categories": null,
  "Prepaid cards": [CardType.VISA],
  "Gift cards": [CardType.MERCHANT_CARDS],
  "Monetary options": [
    CardType.PAYPAL,
    CardType.BANK,
    CardType.VENMO,
    CardType.INSTANT_DEBIT_TRANSFERS,
  ],
  Charities: [CardType.CHARITIES],
}

export type CatalogFilterValue = Partial<Pick<CatalogItem, "name">> & {
  country?: string
  currencyCode?: CurrencyCode
  category: CategoryKey
}
